import { Routes } from '@angular/router';
import { AuthGuard, UnsavedChangesGuard } from '@nagel-services';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { getIsDevelopmentMode } from './utils/environmentUtils';
import { CUSTOMER_COMMUNICATION_ROUTE, PLANNING_ROUTE, TRANSPORT_ROUTE } from './configuration/consts/routesConsts';

export const routes: Routes = [
    {
        path: '',
        redirectTo: PLANNING_ROUTE,
        pathMatch: 'full'
    },
    {
        path: 'order-details/:id',
        loadComponent: () =>
            import('./pages/cal-order-details-page/cal-order-details.component').then(
                (m) => m.OrderDetailsComponent
            ),
        canActivate: [AuthGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: { roles: ['manage-account-links'] }
    },
    {
        path: TRANSPORT_ROUTE,
        loadComponent: () =>
            import('./pages/transport/transport.component').then(
                (m) => m.TransportComponent
            ),
        canActivate: [AuthGuard],
        data: { roles: ['manage-account-links'] }
    },
    {
        path: 'unauthorized',
        component: UnauthorizedComponent,
        data: { roles: ['manage-account-links'] }
    },
    ...(getIsDevelopmentMode() ? [{
        path: 'test',
        loadComponent: () => import('./pages/theme-test/theme-test.component').then(m => m.ThemeTestComponent)
    }] : []),
    {
        path: PLANNING_ROUTE,
        loadComponent: () =>
            import('./pages/planning-page/planning-page.component').then(
                (m) => m.PlanningPageComponent
            ),
        canActivate: [AuthGuard],
        data: { roles: ['manage-account-links'] }
    },
    {
        path: CUSTOMER_COMMUNICATION_ROUTE,
        loadComponent: () =>
            import('./pages/customer-communication/customer-communication.component').then(
                (m) => m.CustomerCommunicationComponent
            ),
        canActivate: [AuthGuard],
        data: { roles: ['manage-account-links'] }
    },
    {
        path: '404',
        loadComponent: () => import('./pages/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent)
    },
    { path: '**', redirectTo: '404' }
];